<template>
    <div>
        <div class="inner-loading" v-show="isLoading">
            <div class="loading-icon">
                <i class="fa fa-sync fa-spin fa-4x fa-fw"></i>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    .inner-loading {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9;

        .loading-icon {
            z-index: 10;
        }
    }
</style>
<script>

    export default {
        props: ['isLoading']
    }

</script>



// WEBPACK FOOTER //
// InnerLoading.vue?346750f8